/**
 * Logs that close the conversation — no next follow-up should be scheduled.
 */
export function isNotInterestedLog(log) {
  if (!log || typeof log !== 'string') return false;
  return /not interested/i.test(log.trim());
}

export function isFutureProspectStage(stage) {
  return stage === 'Future Prospect';
}

/**
 * Whether the Follow Up modal should collect next date + agenda.
 * Terminal stages and "Not Interested" outcomes do not need a next follow-up.
 * Future Prospect always requires a next-contact date (client-told contact date).
 */
export function requiresNextFollowUpFields({ stage, log } = {}) {
  if (isFutureProspectStage(stage)) return true;
  if (stage === 'Deal Closed' || stage === 'Deal Dropped') return false;
  if (isNotInterestedLog(log)) return false;
  return true;
}

/**
 * Outcomes that close the lead out instead of scheduling a next touch still need a
 * written reason, so the drop is auditable in Stage History & logs.
 */
export function requiresClosureNote({ stage, log } = {}) {
  if (requiresNextFollowUpFields({ stage, log })) return false;
  return stage !== 'Deal Closed';
}

export function closureNoteLabel({ stage, log } = {}) {
  if (stage === 'Deal Dropped') return 'Reason For Dropping';
  if (stage === 'Deal Closed') return 'Closing Note';
  if (isNotInterestedLog(log)) return 'Reason — Why Not Interested';
  return 'Closure Note';
}

export function closureNotePlaceholder({ stage, log } = {}) {
  if (stage === 'Deal Dropped') return 'Why is this deal being dropped...';
  if (stage === 'Deal Closed') return 'Anything to note about this closure...';
  if (isNotInterestedLog(log)) return 'Budget, location, timeline, competitor...';
  return 'Why is this lead being closed out...';
}

/**
 * Next contact date for Future Prospect must be today or later (local day).
 */
export function isValidFutureProspectContactDate(followUpDate) {
  if (!followUpDate) return false;
  const parsed = new Date(followUpDate);
  if (Number.isNaN(parsed.getTime())) return false;
  const dayStart = new Date(parsed);
  dayStart.setHours(0, 0, 0, 0);
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  return dayStart >= today;
}
